import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Drawer } from '@mui/material';
import { useTranslation } from 'react-i18next';

import DateFromToFilter from './items/dateFromToFilter';
import OrderStatusFilter from '../ui/filters/items/OrderStatusFilter';
import GenericSelectFilter from './items/GenericSelectFilter';

const OrderFilterDrawer = ({ open, setOpen, isLoading = false }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleResetFiler = () => {
    navigate(location.pathname, { replace: true });
  };

  return (
    <Drawer
      anchor='left'
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: { padding: '18px', background: 'transparent', boxShadow: 'none' },
      }}
    >
      <div className='dashboard-filter-drawer-wrapper !pt-2 first-letter bg-white h-full rounded-lg border border-[#E5E9EB]'>
        <div className='mb-3 text-end flex justify-between items-center border-b'>
          <div className='text-[16px] leading-[16px] font-semibold'>Filter</div>
          <Button
            color='error'
            // variant='outlined'
            className='!-mr-[5px]'
            size='small'
            disabled={isLoading}
            onClick={() => handleResetFiler()}
          >
            {t('common.button.clear')}
          </Button>
        </div>
        <DateFromToFilter
          size='small'
          disabled={isLoading}
          labels={{
            start: 'Sanadan',
            end: 'gacha',
          }}
        />
        <DateFromToFilter
          size='small'
          disabled={isLoading}
          labels={{
            start: 'Yetkazish sanadan',
            end: 'gacha',
          }}
          queries={['delivery_from', 'delivery_till']}
        />
        <GenericSelectFilter
          query='supplier_id'
          path='/dictionary/suppliers'
          label='Yetkazib beruvchi'
        />
        <OrderStatusFilter />
      </div>
    </Drawer>
  );
};
export default OrderFilterDrawer;
